import { getRandomFromInterval } from '../../utils/MathUtils';
import { Loader } from '../../Loader';
import { createSprite } from '../../utils/GameEngine';
import { SceneManager } from './SceneManager';
import { Sprite } from 'pixi.js';

export interface InviteTemplate {
    image: any;
    text: {
        default: string;
        localizations: {
            en_US?: string
            en_UD?: string
            en_GB?: string
            da_DK?: string
            de_DE?: string
            es_LA?: string
            es_ES?: string
            fr_FR?: string
            fr_CA?: string
            it_IT?: string
            nl_BE?: string
            nl_NL?: string
            pl_PL?: string
            pt_BR?: string
            pt_PT?: string
            ro_RO?: string
            ru_RU?: string
            sk_SK?: string
            sv_SE?: string
            th_TH?: string
            tr_TR?: string
            bg_BG?: string
            hr_HR?: string
            el_GR?: string
            ar_AR?: string
        }
    };
    data: {};
}

export class SocialManager {
    private static _instance: SocialManager;
    private templates: InviteTemplate[] = [
        {
            image: 'mod_share_invite',
            text: {
                default: 'Only 10% of players reached level 43. Can you become the Master of Donuts?',
                localizations: {
                    en_US: 'Only 10% of players reached level 43. Can you become the Master of Donuts?',
                    en_UD: 'Only 10% of players reached level 43. Can you become the Master of Donuts?',
                    en_GB: 'Only 10% of players reached level 43. Can you become the Master of Donuts?',
                    da_DK: 'Kun 10% af spillerne nåede niveau 43. Kan du blive Master of Donuts?',
                    de_DE: 'Nur 10% der Spieler haben Level 43 erreicht. Kannst du Master of Donuts werden?',
                    es_LA: 'Solo el 10% de los jugadores alcanzaron el nivel 43. ¿Puedes convertirte en el Master of Donuts?',
                    es_ES: 'Solo el 10% de los jugadores alcanzaron el nivel 43. ¿Puedes convertirte en el Master of Donuts?',
                    fr_FR: 'Seuls 10 % des joueurs ont atteint le niveau 43. Pouvez-vous devenir le Master of Donuts?',
                    fr_CA: 'Seuls 10 % des joueurs ont atteint le niveau 43. Pouvez-vous devenir le Master of Donuts?',
                    it_IT: 'Solo il 10% dei giocatori ha raggiunto il livello 43. Riuscirai a diventare il Master of Donuts?',
                    nl_BE: 'Slechts 10% van de spelers bereikte level 43. Kun jij de Master of Donuts worden?',
                    nl_NL: 'Slechts 10% van de spelers bereikte level 43. Kun jij de Master of Donuts worden?',
                    pl_PL: 'Tylko 10% graczy osiągnęło poziom 43. Czy możesz zostać Master of Donuts?',
                    pt_BR: 'Apenas 10% dos jogadores alcançaram o nível 43. Você pode se tornar o Master of Donuts?',
                    pt_PT: 'Apenas 10% dos jogadores alcançaram o nível 43. Você pode se tornar o Master of Donuts?',
                    ro_RO: 'Doar 10% dintre jucători au ajuns la nivelul 43. Poți deveni Master of Donuts?',
                    ru_RU: 'Только 10% игроков достигли 43-го уровня. Сможете ли вы стать Master of Donuts?',
                    sk_SK: 'Iba 10% hráčov dosiahlo úroveň 43. Môžete sa stať Master of Donuts?',
                    sv_SE: 'Endast 10% av spelarna nådde nivå 43. Kan du bli Master of Donuts?',
                    th_TH: 'ผู้เล่นเพียง 10% ถึงระดับ 43 คุณสามารถเป็น Master of Donuts ได้หรือไม่?',
                    bg_BG: 'Само 10% от играчите достигнаха ниво 43. Можете ли да станете Master of Donuts?',
                    hr_HR: 'Samo 10% igrača doseglo je razinu 43. Možete li postati Master of Donuts? ',
                    el_GR: 'Μόνο το 10% των παικτών έφτασε στο επίπεδο 43. Μπορείτε να γίνετε Master of Donuts;',
                }
            },
            data: {
                payload: '10percent'
            }
        },
    ];

    private constructor() {
    }

    public static getInstance(): SocialManager {
        return this._instance || (this._instance = new this());
    }

    public async getInviteTemplate(): Promise<InviteTemplate> {
        const payload: InviteTemplate = this.templates[getRandomFromInterval(0, this.templates.length - 1)];

        const promise: Promise<InviteTemplate> = new Promise((resolve: any, reject: any): void => {
            Loader.getInstance().loadShareAsset(
                payload.image,
                (resourceName: string): void => {
                    const image: Sprite = createSprite(resourceName);
                    const extract: Extract<any, any> = new PIXI.Extract(SceneManager.getInstance()._app.renderer);
                    payload.image = extract.base64(image);
                }
            );
            resolve(payload);
        });

        return promise;
    }
}